import toUrl from '../domain/toUrl';
import get_bundle from '../domain/get_bundle';
import template from 'lodash/string/template';


export default function doShare(app) {
  return function doShare(type) {
    const bundle = get_bundle(app.locale).social;
    const product = app.product;
    let target = toUrl(app.social_url, {
      lattice: app.lattice && app.is_corp ? app.lattice.id : null
    });
    // appendo un timestamp per indurre facebook a rifare il parsing
    // delle info del prodotto e invalidare la loro cache
    let fb_target = toUrl(target, {
      _: new Date().getTime()
    });
    let fb_caption = null;
    let gplus_target = target;
    let url = '';

    // personalizzazione dello share
    if (app.lattice) {
      if (app.lattice.share_url) {
        target = fb_target = app.lattice.share_url;
      }
      if (app.lattice.share_caption) {
        fb_caption = app.lattice.share_caption;
      }
    }

    switch (type) {
      case 'email':
        url = toUrl('mailto:', {
          subject: bundle.email.subject,
          body: template(bundle.email.body)({
            name: product.name,
            description: bundle.claim,
            target
          })
        });
        break;
      //app_id: '242802885747781',
      case 'facebook':
        url = toUrl('https://www.facebook.com/dialog/feed', {
          app_id: '911642192190441',
          link: fb_target,
          name: product.name,
          description: bundle.claim,
          picture: product.image,
          redirect_uri: 'http://www.facebook.com',
          caption: fb_caption
        });
        break;
      case 'gplus':
        url = toUrl('https://plus.google.com/share', {
          url: gplus_target
        });
        break;
      case 'linkedin':
        url = toUrl('http://www.linkedin.com/shareArticle', {
          mini: 'true',
          url: target,
          title: product.name,
          summary: bundle.claim
        });
        break;
      case 'twitter':
        url = toUrl('https://twitter.com/intent/tweet', {
          source: 'tweetbutton',
          text: product.name + ' ' + bundle.claim,
          url: target,
          via: 'madainews',
          type: 'share',
          twttr_referrer: 'http://madai.com'
        });
        break;
    }

    window.open(url);

    app.emit('go_share', [type]);
  };
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/doShare.js
 **/